import type { FC, ReactNode } from 'react'

import { formatNumber } from '@/lib/format'
import { SectionCard } from '@/components/dashboard/section-card'
import { BarList } from '@/components/charts/bar-list'
import { REGION_BREAKDOWN } from '@/data/metrics'

interface RegionsCardProps {
    className?: string
}

export const RegionsCard: FC<RegionsCardProps> = ({ className }): ReactNode => {
    return (
        <SectionCard
            className={className}
            title='Pelanggan per wilayah'
            description={`Sebaran ${formatNumber(REGION_BREAKDOWN.total)} pelanggan berbayar menurut provinsi.`}
        >
            <BarList
                items={REGION_BREAKDOWN.rows.map((row) => ({ key: row.label, label: row.label, value: row.value }))}
                formatValue={formatNumber}
                showShare
                total={REGION_BREAKDOWN.total}
            />
        </SectionCard>
    )
}
